import React from 'react';
import { CommandBarButton } from '@fluentui/react';
import { useAuthentication } from '../../util/authentication';
import { useHistory } from 'react-router-dom';

export function UserMenu() {
  const { principal, logout } = useAuthentication();
  
  //const { user, token, logout } = useMsal();

  const history = useHistory();
  const menuProps = {
    shouldFocusOnMount: true,
    items: [
      {
        key: 'profile',
        text: 'Profile',
        iconProps: { iconName: 'PlayerSettings' },
        onClick: () => history.push('/profile')
      },
      {
        key: 'logout',
        text: 'Logout',
        iconProps: { iconName: 'SignOut' },
        onClick: logout
      }
    ]
  };

  return (
    <CommandBarButton
      style={{borderRadius: '10px'}}
      menuProps={menuProps}
      iconProps={{ iconName: 'UserOptional' }}>
      {principal.name}
    </CommandBarButton>
  );
}
